<template>
  <div>
    <ul class="list-unstyled">
      <li v-for="(shiurim, index) in data" class="px-5 py-4 pr-md-3 align-items-center text-center text-sm-left" :class="index % 2 == 0 ? 'odd' : 'even'">
        <div class="row d-flex align-items-center">
          <div class="col-md-9 col-sm-7 col-12 mb-3 mb-sm-0">
            <b-img-lazy
              v-if="shiurim.lecturer"
              blank-src="/static/blank_profile.jpg"
              :src="imgsrc(shiurim.lecturer)"
              fluid
              :alt="shiurim.lecturer.name"
              class="img-fluid profile-img d-inline-block col-auto"
            />

            <span class="d-inline-block">
              <div v-if="shiurim.message">
                <strong>{{ shiurim.message }}</strong>
                <br />
              </div>
              <template v-if="shiurim.lecturer">
                <h5 class="font-weight-bolder text-blue">
                  {{ shiurim.lecturer.name }}
                </h5>
                <span v-if="shiurim.length != '00:00'" class="text-blue">
                  <i class="fa fa-clock-o"></i>
                  <span class="ml-1">{{ shiurim.length }}</span>
                </span>
              </template>
            </span>
          </div>

          <div class="col-md-3 col-sm-5 col-12">
            <action-buttons :magid-shiur="shiurim.lecturer ? shiurim.lecturer : null" :shiurim="shiurim" type="shas"></action-buttons>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import ActionButtonsComponent from '../partials/ActionButtons.vue';
export default {
  components: {
    ActionButtons: ActionButtonsComponent,
  },
  props: ['data', 'daf'],
  methods: {
    imgsrc: function (magidShiur) {
      if (magidShiur && magidShiur.image) {
        return magidShiur.image.url;
      } else {
        return '/static/blank_profile.jpg';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.even {
  background-color: $bg-gray;
}
.odd {
  background-color: $white;
}
</style>
